window.SST = window.SST || {};

/**
 * UGC video row + fullscreen reel viewer. The modal itself is Dawn's
 * `modal-dialog` custom element (assets/global.js), which already provides
 * focus trapping, backdrop click-to-close and Escape-to-close, and pauses
 * every <video> on the page when it hides. This only wires the row click,
 * the prev/next/play/mute controls, and which clip is visible.
 */
window.SST.initUgc = function initUgc(root) {
  (root || document).querySelectorAll('[data-sst-ugc]').forEach((section) => {
    if (section.dataset.sstUgcBound === 'true') return;
    section.dataset.sstUgcBound = 'true';

    const modal = document.getElementById(`UgcModal-${section.dataset.sstUgc}`);
    if (!modal) return;

    const cards = Array.from(section.querySelectorAll('[data-sst-ugc-open]'));
    const row = section.querySelector('.sst-ugc__row');
    const scrollPrevBtn = section.querySelector('[data-sst-ugc-scroll-prev]');
    const scrollNextBtn = section.querySelector('[data-sst-ugc-scroll-next]');
    const clips = Array.from(modal.querySelectorAll('[data-sst-ugc-clip]'));
    const prevBtn = modal.querySelector('[data-sst-ugc-prev]');
    const nextBtn = modal.querySelector('[data-sst-ugc-next]');
    const muteBtn = modal.querySelector('[data-sst-ugc-mute]');
    const playBtn = modal.querySelector('[data-sst-ugc-playpause]');
    if (clips.length === 0) return;

    let current = 0;
    // Sound on by default; a card click is a user gesture, so browsers allow
    // it. Falls back to muted only if a specific clip's autoplay is refused.
    let muted = false;

    const updateCarouselNav = () => {
      if (!row || !scrollPrevBtn || !scrollNextBtn) return;
      const hasOverflow = row.scrollWidth > row.clientWidth + 1;
      scrollPrevBtn.hidden = !hasOverflow;
      scrollNextBtn.hidden = !hasOverflow;
      scrollPrevBtn.disabled = row.scrollLeft <= 1;
      scrollNextBtn.disabled = row.scrollLeft >= row.scrollWidth - row.clientWidth - 1;
    };

    const scrollCarousel = (direction) => {
      if (!row || !cards[0]) return;
      const gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      row.scrollBy({ left: direction * (cards[0].getBoundingClientRect().width + gap), behavior: 'smooth' });
    };

    if (row) row.addEventListener('scroll', updateCarouselNav, { passive: true });
    if (scrollPrevBtn) scrollPrevBtn.addEventListener('click', () => scrollCarousel(-1));
    if (scrollNextBtn) scrollNextBtn.addEventListener('click', () => scrollCarousel(1));
    window.addEventListener('resize', updateCarouselNav);
    requestAnimationFrame(updateCarouselNav);

    // Button copy lives in the section markup so it stays translatable.
    const updateMuteUi = () => {
      if (!muteBtn) return;
      muteBtn.classList.toggle('is-muted', muted);
      muteBtn.setAttribute('aria-label', muted ? muteBtn.dataset.labelUnmute : muteBtn.dataset.labelMute);
    };

    const updatePlayUi = (video) => {
      if (!playBtn) return;
      const paused = !video || video.paused;
      playBtn.classList.toggle('is-paused', paused);
      playBtn.setAttribute('aria-label', paused ? playBtn.dataset.labelPlay : playBtn.dataset.labelPause);
    };

    const currentVideo = () => clips[current] && clips[current].querySelector('video');

    const activate = (index) => {
      current = Math.max(0, Math.min(index, clips.length - 1));
      clips.forEach((clip, i) => {
        const video = clip.querySelector('video');
        const isCurrent = i === current;
        clip.hidden = !isCurrent;
        if (!video) return;
        if (isCurrent) {
          video.muted = muted;
          video.currentTime = 0;
          video.play().catch(() => {
            muted = true;
            video.muted = true;
            updateMuteUi();
            video.play().catch(() => {});
          });
        } else {
          video.pause();
        }
      });
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === clips.length - 1;
      updatePlayUi(currentVideo());
    };

    cards.forEach((card, i) => {
      card.addEventListener('click', () => {
        modal.show(card);
        activate(i);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', () => activate(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => activate(current + 1));

    if (playBtn) {
      playBtn.addEventListener('click', () => {
        const video = currentVideo();
        if (!video) return;
        if (video.paused) video.play().catch(() => {});
        else video.pause();
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', () => {
        muted = !muted;
        const video = currentVideo();
        if (video) video.muted = muted;
        updateMuteUi();
      });
    }

    clips.forEach((clip, i) => {
      const video = clip.querySelector('video');
      if (!video) return;
      video.addEventListener('ended', () => {
        if (i < clips.length - 1) activate(i + 1);
      });
      video.addEventListener('play', () => { if (i === current) updatePlayUi(video); });
      video.addEventListener('pause', () => { if (i === current) updatePlayUi(video); });
    });
  });
};

document.addEventListener('DOMContentLoaded', () => window.SST.initUgc());
window.SST.onSectionLoad((section) => window.SST.initUgc(section));
